import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_WikiRoleGuide = _resolveComponent("WikiRoleGuide")!
  const _component_TopRolePlayer = _resolveComponent("TopRolePlayer")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "good-loyalty-icon" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('servant.seoHeading')), 1)
    ]),
    _createVNode(_component_WikiRoleGuide, { role: "servant" }),
    _createVNode(_component_TopRolePlayer, {
      role: "servant",
      class: "my-4"
    }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('servant.strategicTipsTitle')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('servant.tipActiveObservationTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('servant.tipActiveObservationText')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('servant.tipCommunicationTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('servant.tipCommunicationText')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('servant.tipVotingStrategyTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('servant.tipVotingStrategyText')), 1)
      ])
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}